import { AbsencesRoutes } from '../../../pages/Absences/AbsencesRoutes'
import trans from '../../helpers/trans'
import { PermissionSlug } from '../../types/permissionTypes'
import { SubNavRoute } from '../routes'

export type AbsenceNavigationRouteKey =
    'leave-of-absence-requests' |
    'leave-of-absences-calendar' |
    'leave-of-absences-overview' |
    'absences-list' |
    'absences-overview';

const leaveOfAbsencePagePermissions: PermissionSlug[] = [
    'view-all-leave-of-absences',
    'add-new-leave-of-absences',
    'add-new-employee-leave-of-absences',
    'add-new-junior-manager-leave-of-absences',
    'add-new-manager-leave-of-absences',
]

const absenceNavigationRoutes: SubNavRoute[] = [
    {
        key: 'leave-of-absence-requests',
        hasSomePermission: true,
        path: AbsencesRoutes.leaveOfAbsenceRequests(),
        label: trans('routes.absences.leaveOfAbsenceRequests.label'),
        permissions: leaveOfAbsencePagePermissions,
    },
    {
        key: 'leave-of-absences-calendar',
        hasSomePermission: true,
        path: AbsencesRoutes.leaveOfAbsencesCalendar(),
        label: trans('routes.absences.leaveOfAbsencesCalendar.label'),
        permissions: leaveOfAbsencePagePermissions,
    },
    {
        key: 'leave-of-absences-overview',
        path: AbsencesRoutes.leaveOfAbsencesOverview(),
        label: trans('routes.absences.leaveOfAbsencesOverview.label'),
        permissions: ['action-view-leave-of-absences'],
    },
    {
        key: 'absences-list',
        path: AbsencesRoutes.absencesList(),
        label: trans('routes.absences.absencesList.label'),
        permissions: ['view-all-absences'],
    },
    {
        key: 'absences-overview',
        path: AbsencesRoutes.absencesOverview(),
        label: trans('routes.absences.absencesOverview.label'),
        permissions: ['view-all-absences'],
    },
]

export default absenceNavigationRoutes
